import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { CountryState } from "./CountryState";
import Model from "./Model";
export default class City extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'city_id',
      content: null
    });
    _defineProperty(this, "CityId", {
      fieldName: 'city_id',
      content: null
    });
    _defineProperty(this, "CityRegion", {
      fieldName: 'city_country_state',
      model: CountryState,
      content: null
    });
    _defineProperty(this, "CityName", {
      fieldName: 'city_name',
      content: null
    });
    _defineProperty(this, "CityNameNative", {
      fieldName: 'city_name_native',
      content: null
    });
  }
  getNativeName() {
    return this.CityNameNative.content;
  }
  getName() {
    return this.CityName.content;
  }
}